import { A3LCompany } from '../models/a3Lcompany.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { A3LCompanyPayConcepts } from '../models/a3LCompanyPayConcepts.model';
import { A3LCompanyAgreements } from '../models/a3LCompanyAgreements.model';
import { A3LCompanyWorkplaces } from '../models/a3LCompanyWorkplaces.model';
import { A3LCompanyAvailableJobPositions } from '../models/a3LCompanyAvailableJobPositions.model';
import { A3LRegime } from '../models/a3LRegime.model';
import { A3LTariffGroup } from '../models/a3LTariffGroup.model';

@Injectable()
export class A3LCompanyService
  extends HttpClientBaseService
  implements IServiceBase<A3LCompany>
{
  constructor(_http: HttpClient) {
    super(_http, 'companies/');
  }
  getPagedModels(
    parentId?: any,
    params?: HttpParams
  ): Observable<PageList<A3LCompany>> {
    throw new Error('Method not implemented.');
  }
  getAllModels(parentId?: any, params?: HttpParams): Observable<A3LCompany[]> {
    return this.getAll(parentId, params);
  }

  getModel(id: any, parentId?: any): Observable<A3LCompany> {
    return this.getSingle(id);
  }

  getByIds(ids: number[]): Observable<A3LCompany[]> {
    return this.http.post<A3LCompany[]>(this.getUrl(), ids);
  }

  getPayConcepts(companyCode: string): Observable<A3LCompanyPayConcepts[]> {
    return this.get<A3LCompanyPayConcepts[]>(
      `${this.getUrl(companyCode)}/payConcepts`
    );
  }

  getWorkplaces(companyCode: string, params: HttpParams): Observable<PageList<A3LCompanyWorkplaces>> {
    return this.get(`${this.getUrl(companyCode, null)}/Workplaces`)
  }

  getAgreements(companyCode: string): Observable<A3LCompanyAgreements[]> {
    return this.get<A3LCompanyAgreements[]>(
      `${this.getUrl(companyCode)}/agreements`
    );
  }

  getAllForSelect(onlyConfigured: boolean = false, gestionEmpleados: boolean = false): Observable<A3LCompany[]> {
    const params = new HttpParams()
      .set('onlyConfigured', String(onlyConfigured))
      .set('gestionEmpleados', String(gestionEmpleados));

    return this.get(`${this.getUrl()}forSelect`, params);
  }

  getEmployeesExtraPays(
    companyCode: string,
    agreementCode: string
  ): Observable<string[]> {
    return this.get<string[]>(
      `${this.getUrl(
        companyCode
      )}/agreements/${agreementCode}/employeesextrapays`
    );
  }

  getJobPositions(companyCode: string): Observable<A3LCompanyAvailableJobPositions[]> {
    return this.get<A3LCompanyAvailableJobPositions[]>(`${this.getUrl(companyCode)}/jobPositions`);
  }

  getRegimes(companyCode: string): Observable<A3LRegime[]> {
    return this.get<A3LRegime[]>(`${this.getUrl(companyCode)}/regimes`);
  }

  getTariffGroups(companyCode: string, regime: string): Observable<A3LTariffGroup[]> {
    return this.get<A3LTariffGroup[]>(`${this.getUrl(companyCode)}/regimes/${regime}/tariff-groups`);
  }
}
